/**
 * True when a request targets external object storage (AWS S3) — e.g. the presigned
 * PUT the browser makes to upload an attachment directly to the quarantine bucket.
 *
 * Internal correlation headers (`x-ninety-request-id`, `ninety-origin`) must NOT be
 * attached to these requests. A cross-origin `PUT` already triggers a CORS preflight,
 * and any custom request header forces the bucket's CORS `AllowedHeaders` to explicitly
 * allow-list it — otherwise the preflight fails and the upload dies with a masked
 * `status 0` / 0 bytes. S3 has no use for these headers anyway. See DEV-26988.
 */
export function isExternalStorageUrl(url: string): boolean {
  try {
    return new URL(url, location.origin).hostname.endsWith('.amazonaws.com');
  } catch {
    return false;
  }
}
